import type { NetKind, NetVia } from '../api/protocol';
import { describeNetPath } from '../voice/netStats';

/** Icone a linea (stroke = currentColor), viewBox 24x24. */
function NetGlyph({ kind, size }: { kind: NetKind | 'unknown'; size: number }) {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true,
  };
  if (kind === 'relay') {
    // pila di server
    return (
      <svg {...common}>
        <rect x="4" y="3.5" width="16" height="7" rx="1.5" />
        <rect x="4" y="13.5" width="16" height="7" rx="1.5" />
        <path d="M7.5 7h.01M7.5 17h.01M11 7h5M11 17h5" />
      </svg>
    );
  }
  // diretto (e sconosciuto, in grigio): cerchio aperto con due frecce opposte
  return (
    <svg {...common}>
      <path d="M4.6 8.2A9 9 0 0 1 18 4.8" />
      <path d="M19.4 15.8A9 9 0 0 1 6 19.2" />
      <path d="M6.5 10h11l-3-3M17.5 14h-11l3 3" />
    </svg>
  );
}

/**
 * Badge con il tipo di collegamento di rete di un giocatore, nell'angolo della sua testa:
 * frecce verdi = diretto (UDP), server ambra = tramite relay (TURN o TCP),
 * grigio = dato non ancora disponibile (browser vecchio, bot, misura in corso).
 */
export function NetIndicator({ net, via, testId }: { net?: NetKind; via?: NetVia; testId: string }) {
  const known = !!net && !!via;
  const kind: NetKind | 'unknown' = known ? net! : 'unknown';
  const label = known ? describeNetPath({ net: net!, via: via! }) : 'Tipo di connessione non ancora disponibile';
  return (
    <span
      className={`net-ind is-${kind}`}
      role="img"
      aria-label={label}
      title={label}
      data-testid={testId}
      data-net={known ? net : 'unknown'}
      data-via={known ? via : undefined}
    >
      <NetGlyph kind={kind} size={12} />
    </span>
  );
}
